import React from "react";
import styles from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.shell}>

        {/* Left — Brand */}
        <section className={styles.brand}>
          <h2>Happy Horizon</h2>
          <p>
            A thoughtfully designed learning environment where children
            grow with confidence, creativity, and care.
          </p>
        </section>

        {/* Center — Address */}
        <section className={styles.address}>
          <h4>Address</h4>
          <address>
           F71, Plot No: 273<br />
           2nd Main Rd, Block F,<br />
           Annanagar East,<br />
            Chennai, Tamil Nadu 600102<br />
            India
          </address>
        </section>

        {/* Right — Contact */}
        <section className={styles.contact}>
          <h4>Contact</h4>
          <a href="tel:+91 9940622249">+91 9940622249</a>
          <a href="tel:+91 9712323456">+91 9712323456</a>
          <a href="mailto:Globetots1@gmail.com">Globetots1@gmail.com</a>
          <a
            className={styles.map}
            href="https://maps.app.goo.gl/WYoABo7P7ZVNKAra6"
            target="_blank"
            rel="noopener noreferrer"
          >
            View on Google Maps
          </a>
        </section>

      </div>

      {/* Bottom */}
      <div className={styles.bottom}>
        © {new Date().getFullYear()} Happy Horizon. All rights reserved.
      </div>
    </footer>
  );
}
